import React from 'react'
import styled from 'styled-components'
import { Box, Flex, Text, Image } from 'rebass/styled-components'
import { connect } from 'react-redux'
import { Link } from 'gatsby'
import Moment from 'react-moment'
import Newsletter from '../components/forms/Newsletter'
import NewsletterDialog from '../modules/NewsletterDialog'
import Social from '../components/general/Social'
import CookieBanner from './CookieConsent'

const ContentInfo = styled(Box)` 
    ul {
        border-color: ${(props) => props.theme.colors.white};
        border-style: solid;
        border-width: 0 0 0 1px;
        list-style: none;
        margin: 0;
        padding-bottom: ${(props) => props.theme.space.xxs};
        padding-left: ${(props) => props.theme.space.sm};    
        padding-right: 0;
        padding-top: ${(props) => props.theme.space.xxs};

        li {
            margin-top: ${(props) => props.theme.space.xxs};

            &:first-child {
                margin-top: 0;
            }
        }
    }

nav {
    a {
        color: ${(props) => props.theme.colors.white};
        display: inline-block;
        text-decoration: none;
        position: relative;
        overflow: hidden;
        padding-bottom: 5px;

        &::before {
            background-color: ${(props) => props.theme.colors.white};
            bottom: 0;
            content: '';
            display: inline-block;
            height: 2px;
            left: 0;
            opacity: 0;
            position: absolute;
            transition-duration: 150ms, 350ms;
            transition-timing-function: ease-in, cubic-bezier(0.77,0.0,0.175,1);
            transition-property: opacity, transform;
            transform: translateX(-100%);
            width: 100%;
            will-change: opacity, transform;
            z-index: 0;
        }

        &:hover::before {
            opacity: 1.0;
            transform: translateX(0);
        }

        &[aria-current=page] {
            opacity: 0.5;
            pointer-events: none;
        }
    }
}
`

const Footer = () => {
    return (
        <>
            <ContentInfo
                bg="black"
                pb="md"
                pl="md"
                pr="md"
                pt="md">
                <NewsletterDialog />
                <Flex
                    flexWrap="wrap"
                >
                    <Box
                        flexShrink="0"
                    >
                        <Flex
                            flexDirection="column"
                            height="100%"
                        >
                            <Box
                                flexGrow="1"
                                pb="lg"
                                pr="xxl"
                            >
                                <Link to="/" aria-label="Link to homepage">
                                    <Image
                                        alt="Link to Kidston homepage"
                                        decoding="async"
                                        height="92px"
                                        loading="lazy"
                                        width="268px"
                                        src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 68.9'%3E%3Cpath d='M79.7 15.6l-.7-.7 1-1 .9 1.1a9.1 9.1 0 011.8 3.1 14 14 0 015.9-4.8 34.2 34.2 0 0112.4-2.8v1h-.3c-8.7.5-16.4 3.2-18.4 9.8h-.1a12 12 0 00-2.4-5.8zm1.6 11.6c.7-4.4-.7-9.6-2.3-10.9l.7-.7-.7-.7-.9.8.9 1-.9-1-1.1 1 1.2 1 .7-.9-.7.9a7.5 7.5 0 01.7 1.2 23 23 0 01.9 2.5 17.8 17.8 0 01.3 6.1l1.2.2zM90.5 53l.2.8 1.4-.4-.5-1.7-1.5.9.2.4c.1.1.2.1.2 0zm7.6-16.9l-9.3 6.2 1.4-8.9c.6-.5 2.9-2 3.6-2s3.7 3.3 4.3 4.7zM94 32.3zm.6 1.3l-.5-.2h-.3l-.9.5-1.2.8-.9 5.4 5.8-3.8a16.2 16.2 0 00-1-1.8 9.3 9.3 0 00-1-.9zm2.5 28.8l.9.5.7-.6-.9-1zm13.1-10.3l-1.2.4 1.2-.4-.3-.7-1.2.5 1.2-.5-.5-1.5-1.4.8-1 .5h-.3a5.1 5.1 0 01-.1-1.8c0-4.6-.8-9.4-3.7-13l4.2-2.8 1.1-.9a3 3 0 00.8-1.7l-1.3-.2 1.3.2a5 5 0 00-1.1-3.5 28.3 28.3 0 00-4.3-4.5l-.8-.7-.9.7c-3.1 2.5-6.3 4.9-9.5 7.1l1.3-7.8-1.6-.2h.2l1.4.2a12.7 12.7 0 011.8-5.6 5.1 5.1 0 014.4-2.2v-1.2 1.2h2.5l.2-1.1-1.1-.2 1.1.2.2-1.2.3-1.7H101v1h.1l-.2 1.2h-1.4c-5.2.3-6.6 4-7.4 8.8l-1.7 10.8a136 136 0 0012-8.8c3.9 3.4 5 5.5 4.8 6.7a2.4 2.4 0 01-1.3 1.5l-5.3 3.7c3.3 3.2 4.3 8.1 4.2 13.1v.8c0 1.2.2 2.6 1.5 2.5h.3v-.3.3a5.6 5.6 0 001.6-.7l.3.6c-3.8 2.8-7.3 5.7-11 8.7-3.3-2-3.4-4.7-3.1-8.7s-.3-7.5-2.6-10.2l-3.2 2-1.2 7.5a2.8 2.8 0 01-.1.9c0 1.2.3 1.9 1.3 1.8a4.8 4.8 0 001.7-.5l-.2-.4-.8.3-.5.2v-.2c0-.2.1-.6.1-1l1.2-7.1 1.6-1a13.3 13.3 0 011.6 8.4 17.1 17.1 0 00.3 5.6 7.2 7.2 0 003.5 4.4l.7-1.1.9 1c3.7-2.9 7.3-5.9 11-8.7l-.4-.5.4.5.8-.6zm-36.6 3.3c0-.1 0-.1-.1-.1v-1.2h-1l-.2 1.1 1.3.3zm17.1-1.5a53.1 53.1 0 00-9.7 7.2 12.9 12.9 0 00-7.4-5.7l-1.3-.3-.2.9v1.2l1.1.3a11.3 11.3 0 016.8 5.3l1.1-.8 1 1.1a51.8 51.8 0 019.6-7.3l-.4-.7.4.7.9-.5-.2-1-1.1.3 1.1-.3-.2-.8-1.4.4zm-13.2-2.6c.1-.3.1-.5.2-.8l3.6-22.8-1.2-.2-3.8 23.6 1.2.2zm-3.8 3.2c2.5-.1 3.4-1.1 3.8-3.2l-1.2-.2a5.2 5.2 0 01-.7 2.4c-.3.3-.7.6-2 .6v.4zm6.2 8.4l.8 1.4 1.3-1.1-1-1.1zM199.6 7h-.1c0 .9.1 0 .1 0zm.4 23.8s-28.1 13.2-30.6 9V29.7l.7.3 1.4 8.1c3-2.5 7.9-7.3 4.7-8.6s-20.8-5.5-63.9 20.7a2 2 0 00-.2-.7s47.3-30.7 64.7-22.8c0 .1 2 1 2.8 2.5 1.3 3.7-6.6 9.5-6.6 9.5s13.3-2.7 22.8-8.6l-6.4-7.7 4.3-11.1s-6.4 3.6-10.3 4.2a12 12 0 01-4.2.1v8.2l-.8-.3c-.8-4.5-1-12.1-1.1-21.3-7.6-2.5-43.7 2.9-71.1 18.3-.1-.2-.2.3-.8-.4C119.4 11 162-4.1 179.2 1a5.8 5.8 0 01.2 1.5v11.6c2.5.1 11.7-1.8 20.3-7.2 0 .1 0 .2-.1.2l-7 14.7zM21.9 36.4a6.4 6.4 0 002.6 2.7c16.6 9.4 53-9.1 53-9.1s.1-.8.1-1c-27.1 12.6-43.9 13-52.1 8.3-3-1.7 2-5.8 5.2-8.1l.9 9.1.6-.4.8-10.2c-2.1-4.5-31.3 5.4-31.3 5.4l6.7 9.5L0 56.7s.2-.1 0 1.1c9-4.7 18.3-5.7 20.8-5.5L19.7 63h.1a11.5 11.5 0 00-.3 3c18 5.6 38.4 2.2 52.9-5.1-.7-.3.2-.8-.4-.8-24.2 11.3-42.8 6.5-50.1 3.3.7-9.2 1.2-16.8.8-21.3l-.8-.3-.8 8.2a12.2 12.2 0 00-4.2-.2C12.9 50 6.3 53 6.3 53l5.2-10.6-5.7-8.3c10-5 23.4-6.6 23.4-6.6s-8.3 5.1-7.3 8.9zm97.6-1l-2-3.5-1.8 1.1 1.9 3.5-1 .6-4.4-7.9 1-.6 2 3.5L117 31l-2-3.5 1-.6 4.5 7.9zm2.1-1.3l-4.4-7.9 1-.6 4.4 7.9zm3.9-2a2 2 0 01-2.8-.7l-.4-.8 1-.5.3.6q.6 1.1 1.5.6a1 1 0 00.4-1.5 3.1 3.1 0 00-2.2-1.4 4.4 4.4 0 01-3-1.7 2.1 2.1 0 01.9-2.9 1.9 1.9 0 012.8.8l.3.7-.9.6-.4-.7c-.3-.6-.8-.9-1.4-.5a.9.9 0 00-.4 1.2c.4.8 1 1.1 2.4 1.4a3.6 3.6 0 012.8 1.8 2.1 2.1 0 01-.9 3zm1.4-10l3.4 7.3-1 .5-3.5-7.2-1.4.7-.4-1 3.8-1.9.5.9zm7.5 5.5a2 2 0 01-2.9-1.1l-2-4.5a2.1 2.1 0 011.1-3 2 2 0 012.9 1.1l2 4.5a2.1 2.1 0 01-1.1 3zm-2-7.1a1.1 1.1 0 00-1.4-.6 1.1 1.1 0 00-.5 1.5l2.1 4.7a.9.9 0 001.4.6 1.1 1.1 0 00.5-1.5zm9 4.1c-.8.3-1.2.2-1.5-.6l-.7-2a.8.8 0 00-1.1-.5l-1 .4 1.4 3.7-1.1.4-3.1-8.5 2.1-.8a1.6 1.6 0 012.4 1l.4 1.3a1.3 1.3 0 01-.4 1.7 1.4 1.4 0 011.5 1l.6 1.8a.4.4 0 00.5.2l.3.7zm-3.7-6.5c-.2-.5-.5-.7-1-.5l-1 .4 1.1 3 .9-.4a.8.8 0 00.5-1.1zm5.9 1.8l1 3.4-1.1.4-1-3.5-3.4-4.6 1.1-.4 2.5 3.6v-4.4l1.1-.4zm8.5 1.4l-.8-2-1.6.4v2.1l-1 .3-.6-9.4 1.2-.2 3.9 8.5zm-2.8-6.6l.3 4 1.3-.4zm4.8 6.2l-1.6-9.1 1.2-.2 1.3 8 2.4-.4.2 1.1zm9.3-1.3h-1.2l-2.3-9.1h1.2l1.6 7 .7-7.1h1.2zm-6-8.6h1.1l1.2 9.1m0 0h-1.2l-1.1-9.1m8.4 8.4v-9.2h3.6v1.1H167v2.9h1.8v1H167v3.2h2.5v1zM34.3 58.8L33 54.7l-.6 1.3v2.7h-1.3l.3-9.2h1.2l-.2 4.7 2.2-4.6h1.2l-2 3.9 1.7 5.3zm2.8.1v-9.2h3.6v1h-2.5v2.9H40v1h-1.8v3.2h2.5v1.1zm5.4-.1l-.5-9.2 3.6-.2v1.1h-2.4l.2 2.9h1.7v1h-1.7l.2 3.2H46v1zm7.1-4.3h-1l.4 3.8h-1.1l-1.1-9.1 2.2-.3a1.7 1.7 0 012.1 1.7l.2 1.6a1.8 1.8 0 01-1.7 2.3zm.3-3.7c-.1-.5-.3-.7-.8-.7l-1.1.2.4 3.3h1.1a.7.7 0 00.6-.9zm3.8 6.9l-1.7-9 1.1-.2 1.7 9zm6.6-1.5l-3.1-3.9-1-1.3 1.7 5.9-1 .3-2.6-8.9.9-.3 3.1 4 .9 1.3-1.7-5.9 1.1-.3 2.5 8.8zm6.7-2.8l-.5-.5a1.6 1.6 0 01-1 1.4 2 2 0 01-2.8-1.1l-2.2-4.6a2 2 0 011-2.9c1.2-.7 2.2-.1 2.8 1l.4.8-1 .5-.4-.9a1 1 0 00-1.4-.5.9.9 0 00-.4 1.3l2.3 4.9a1 1 0 001.4.5 1.1 1.1 0 00.5-1.4l-.8-1.6-.9.5-.4-.9 1.9-.9 2 4.1z' fill='%23fff' /%3E%3C/svg%3E"
                                    />
                                </Link>
                            </Box>
                            <Box>
                                <Text
                                    as="span"
                                    color="white"
                                    fontSize="sm"
                                    sx={{
                                        '@media screen and (max-width: 650px)': {
                                            display: 'none',
                                        },
                                    }}
                                >&#169; <Moment format="YYYY" /> Kidston</Text>
                            </Box>
                        </Flex>
                    </Box>
                    <Box
                        flexGrow="1"
                        flexShrink="0"
                    >
                        <Flex
                            justifyContent="flex-end"
                        >
                            <Box
                                flexBasis="600px"
                            >
                                <Newsletter />
                                <Flex
                                    alignContent="flex-start"
                                    alignItems="flex-start"
                                    className="navigation"
                                    pt="md"
                                >
                                    <Box
                                        flexBasis="50%">
                                        <Box as="nav" role="navigation" arial-label="Footer">
                                            <ul>
                                                <li><Link to="/about/">About</Link></li>
                                                <li><Link to="/cars-for-sale/available/">Cars</Link></li>
                                                <li><Link to="/restorations/">Restorations</Link></li>
                                                <li><Link to="/about/services/">Services</Link></li>
                                                <li><Link to="/films/">Films</Link></li>
                                                <li><Link to="/publications/">Publications</Link></li>
                                                <li><Link to="/contact/">Contact</Link></li>
                                                <li><Link to="/terms/">Terms</Link></li>
                                                <li><Link to="/privacy/">Privacy</Link></li>
                                            </ul>
                                        </Box>
                                    </Box>
                                    <Box className="cell" pl='sm' pb='xs' sx={{
                                        borderColor: 'white',
                                        borderWidth: '0 0 0 1px',
                                        borderStyle: 'solid',
                                    }}>
                                        <Social />
                                    </Box>
                                </Flex>
                            </Box>
                        </Flex>
                    </Box>
                </Flex>
                <Text
                    as="span"
                    color="white"
                    fontSize="sm"
                    pt="md"
                    sx={{
                        display: 'none',
                        '@media screen and (max-width: 650px)': {
                            display: 'block',
                        },
                    }}
                >&#169; <Moment format="YYYY" /> Kidston</Text>
            </ContentInfo>
            <CookieBanner />
        </>
    )
}

function mapStateToProps(state) {
    return {}
}
export default connect(mapStateToProps)(Footer)
